export interface TeamMembershipArgument {
  userID: string
  teamID: string
  challengeID: string
}

export default class TeamMembership {
  readonly userID: string
  readonly teamID: string
  readonly challengeID: string

  constructor(arg: TeamMembershipArgument) {
    this.userID = arg.userID
    this.teamID = arg.teamID
    this.challengeID = arg.challengeID
  }

  static fromPG(data: any) {
    return new TeamMembership({
      userID: data.user_id,
      teamID: data.team_id,
      challengeID: data.challenge_id,
    })
  }

  toPG() {
    return {
      user_id: this.userID,
      team_id: this.teamID,
      challenge_id: this.challengeID,
    }
  }
}
